import React from 'react';
import { Skeleton } from '@components/ui/skeleton';
import cn from 'classnames';
interface WhyForeverCardsLoaderProps {
  count?: number;
}
const WhyForeverCardsLoader: React.FC<WhyForeverCardsLoaderProps> = ({
  count = 3
}) => {
  const skeletonCards = Array.from({
    length: count
  });
  return <section className="py-12" data-sentry-component="WhyForeverCardsLoader" data-sentry-source-file="why-forever-cards-loader.tsx">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {skeletonCards.map((_, index) => <div key={index} className={cn('flex flex-col justify-between bg-gray-200 dark:bg-neutral-700 rounded-lg shadow-lg overflow-hidden animate-pulse border border-neutral-200 dark:border-neutral-800', 'min-h-[400px]')}>
              <div className="p-4">
                <div className="relative">
                  <Skeleton className="w-full h-72 object-cover rounded-md" aria-label="Loading image" />
                  <div className="absolute bottom-0 left-2 right-2">
                    <Skeleton className="h-6 w-3/4 mx-auto" aria-label="Loading title" />
                  </div>
                </div>
                <div className="p-4">
                  <Skeleton className="h-4 w-full mb-2" aria-label="Loading description line 1" />
                  <Skeleton className="h-4 w-5/6 mb-2" aria-label="Loading description line 2" />
                  <Skeleton className="h-4 w-4/6" aria-label="Loading description line 3" />
                </div>
              </div>
              <div className="p-4">
                <Skeleton className="h-10 w-full rounded-lg" aria-label="Loading button" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default React.memo(WhyForeverCardsLoader);